import React from "react";
import { View, StyleSheet } from "react-native";
import { ShimmerBox } from "../../../components/skeletons";

const StatCardSkeleton: React.FC = () => (
  <View style={styles.statCard}>
    <View style={styles.statCardHeader}>
      <ShimmerBox width={48} height={48} borderRadius={24} />
    </View>
    <ShimmerBox width={56} height={36} borderRadius={8} style={{ marginBottom: 8 }} />
    <ShimmerBox width="70%" height={12} borderRadius={6} style={{ marginBottom: 6 }} />
    <ShimmerBox width="50%" height={11} borderRadius={6} style={{ marginBottom: 12 }} />
    <View style={{ flexDirection: "row", alignItems: "center", gap: 4 }}>
      <ShimmerBox width={80} height={11} borderRadius={6} />
    </View>
  </View>
);

const styles = StyleSheet.create({
  statCard: {
    flex: 1,
    backgroundColor: "rgba(255,255,255,0.6)",
    borderRadius: 24,
    padding: 24,
    borderWidth: 1,
    borderColor: "#EAECF0",
    minHeight: 180,
  },
  statCardHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 16,
  },
});

export default StatCardSkeleton;
